import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  howWouldYouLikeToReceiveThisOrder: {
    id: 'howWouldYouLikeToReceiveThisOrder',
    defaultMessage: 'How would you like to receive this order?',
    description: 'A question to encourage users to choose a service mode.'
  },
  cateringPickUpAt: {
    id: 'cateringPickUpAt',
    defaultMessage: 'Catering Pick up at',
    description:
      'A note preceding a restaurant address to indicate to the user where they should pick up their catering order.'
  },
  dineInAt: {
    id: 'dineInAt',
    defaultMessage: 'Dine in at',
    description:
      'A note preceding a restaurant address - the whole phrase will indicate which location the user has ordered from for dine-in service mode.'
  },
  curbsideAt: {
    id: 'curbsideAt',
    defaultMessage: 'Curbside at',
    description:
      'A note preceding a restaurant address - the whole phrase will indicate which location the user has ordered from for curbside pickup.'
  },
  pickUpAt: {
    id: 'pickUpAt',
    defaultMessage: 'Pick up at',
    description:
      'A note preceding a restaurant address - the whole phrase will indicate which location the user should pick up their order at.'
  },
  driveThruAt: {
    id: 'driveThruAt',
    defaultMessage: 'Drive-thru at',
    description:
      'A note preceding a restaurant address - the whole phrase will indicate which location the user has order from for drive-thru pickup.'
  },
  deliverTo: {
    id: 'deliverTo',
    defaultMessage: 'Deliver to',
    description:
      "A note preceding the user's address - the whole phrase will indicate where the user's order will be delivered to."
  },
  orderingFrom: {
    id: 'orderingFrom',
    defaultMessage: 'Ordering from',
    description:
      'A note preceding a restaurant address - the whole phrase will indicate which location the user is ordering from.'
  },
  pickUpAtSelectALocation: {
    id: 'pickUpAtSelectALocation',
    defaultMessage: 'Pick up at: select a location',
    description: 'A note encouraging the user to select a location for order pick-up.'
  },
  driveThru: {
    id: 'driveThru',
    defaultMessage: 'Drive Thru',
    description: 'The name of a service mode: drive-thru.'
  },
  dineIn: {
    id: 'dineIn',
    defaultMessage: 'Dine in',
    description: 'The name of a service mode: dine in.'
  },
  takeOut: {
    id: 'takeOut',
    defaultMessage: 'Take Out',
    description: 'The name of a service mode: take out.'
  },
  curbside: {
    id: 'curbside',
    defaultMessage: 'Curbside',
    description: 'The name of a service mode: curbside pickup.'
  },
  delivery: {
    id: 'delivery',
    defaultMessage: 'Delivery',
    description: 'The name of a service mode: delivery.'
  },
  cateringDelivery: {
    id: 'cateringDelivery',
    defaultMessage: 'Catering Delivery',
    description: "The name of a service mode: catering delivered to customer's address."
  },
  cateringPickUp: {
    id: 'cateringPickUp',
    defaultMessage: 'Catering Pick Up',
    description: 'The name of a service mode: catering with pick up by customer.'
  },
  yourSelectedRestaurantIs: {
    id: 'yourSelectedRestaurantIs',
    defaultMessage: 'Your selected restaurant is {storeAddress}',
    description: 'A note to tell users what restaurant they have selected to order from.'
  },
  selectRestaurantToViewOffers: {
    id: 'selectRestaurantToViewOffers',
    defaultMessage: 'Select a restaurant to view local offers',
    description: 'A note to the user that they can select a restaurant - followed by link.'
  },
  forItemAvailability: {
    id: 'forItemAvailability',
    defaultMessage: 'For item availability',
    description: 'Call to action text for user to select restaurant'
  }
});
